import { createFileRoute, Navigate } from '@tanstack/react-router';

export const Route = createFileRoute('/_app/settings/call-templates')({
    component: CallTemplatesRedirect,
});

// Voice opening lines now live with the outreach templates on the Scheduling
// page, so the standalone Call templates page redirects there.
function CallTemplatesRedirect() {
    return <Navigate to="/settings/outreach-automation" replace={true} />;
}
